import React from 'react';

import CardNumberIcon from './card-number.svg';

export default props => <img {...props} src={CardNumberIcon} alt="" />;
